
export enum CustomReportHelpContentType {

    Default = 'default'

}